import { useState } from "react";
import { MODAL_STYLES } from "../../constants/modal-styles";
import { ModalButton } from "./ModalButton";

interface LeaveMessageTextOnlyModalProps {
  isOpen: boolean;
  language: "ka" | "en";
  onSave: (text: string) => void;
  onCancel: () => void;
}

export const LeaveMessageTextOnlyModal = ({
  isOpen,
  language,
  onSave,
  onCancel,
}: LeaveMessageTextOnlyModalProps) => {
  const [text, setText] = useState("");

  if (!isOpen) return null;

  const content = {
    ka: {
      title: "შეტყობინების ტექსტი",
      subtitle: "დაწერეთ თქვენი შეტყობინება",
      placeholder: "შეიყვანეთ ტექსტი...",
      saveButton: "შემდეგი (აირჩიეთ ადგილი)",
      cancelButton: "გაუქმება",
      errorEmpty: "გთხოვთ შეიყვანოთ ტექსტი",
    },
    en: {
      title: "Message Text",
      subtitle: "Write your message",
      placeholder: "Enter text...",
      saveButton: "Next (Choose location)",
      cancelButton: "Cancel",
      errorEmpty: "Please enter text",
    },
  };

  const translations = content[language] || content.ka;

  const handleSave = () => {
    if (!text.trim()) {
      alert(translations.errorEmpty);
      return;
    }
    onSave(text);
    setText("");
  };

  const handleCancel = () => {
    setText("");
    onCancel();
  };

  return (
    <div className={MODAL_STYLES.overlay} onClick={handleCancel}>
      <div
        className={MODAL_STYLES.modal}
        onClick={(e) => e.stopPropagation()}
        style={{
          fontFamily: MODAL_STYLES.fontFamily,
        }}
      >
        <div className={MODAL_STYLES.content}>
          <h2 className={MODAL_STYLES.title}>{translations.title}</h2>

          <p className="text-amber-900 text-sm sm:text-base mb-4 text-center">
            {translations.subtitle}
          </p>

          <textarea
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder={translations.placeholder}
            className="w-full h-32 p-3 mb-6 bg-white border-2 border-amber-600 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-amber-500 text-amber-900"
            style={{ fontFamily: MODAL_STYLES.fontFamily }}
          />

          <div className={MODAL_STYLES.buttonContainer}>
            <ModalButton onClick={handleSave} fullWidth={true}>
              <span className="text-sm sm:text-base">{translations.saveButton}</span>
            </ModalButton>

            <ModalButton onClick={handleCancel} variant="secondary">
              <span className="text-sm sm:text-base">{translations.cancelButton}</span>
            </ModalButton>
          </div>
        </div>
      </div>
    </div>
  );
};
